import _memoize from 'lodash/memoize';
import _get from 'lodash/get';
import { ROUTING_LOCATION_CHANGE, setIsTopLevelRoute } from '../logic/routing/routing.actions';
import { FETCH_NAVIGATION_SUCCESS, fetchLayout } from '../logic/layout/layout.actions';
import { getLayoutNavigation } from '../logic/layout/layout.selectors';
import { getCurrentPath } from '../logic/routing/routing.selectors';
import { actionToPath } from '../modules/sidenav/sidenav.utils';
import { RESTRICTED_PATHS } from '../modules/sidenav/sidenav.constants';
import { RENEW_TOKEN_SUCCESS } from '../logic/pairing/pairing.actions';

export const actionsToPaths = _memoize(navigation =>
  _get(navigation, 'entries', []).flatMap(group => group.map(({ entry }) => actionToPath({ action: entry }))),
);

export const isTopLevelRoute = route => !RESTRICTED_PATHS.some(path => route.startsWith(path));

export default ({ getState, dispatch }) =>
  next =>
  action => {
    switch (action.type) {
      case ROUTING_LOCATION_CHANGE: {
        const navigation = getLayoutNavigation(getState());
        dispatch(setIsTopLevelRoute(isTopLevelRoute(action.path, navigation)));
        break;
      }
      case FETCH_NAVIGATION_SUCCESS: {
        const { navigation } = action;
        const route = getCurrentPath(getState());
        dispatch(setIsTopLevelRoute(isTopLevelRoute(route, navigation)));
        break;
      }
      // In order to avoid circular dependencies between layout fetching and locks resolution,
      // each time a new profile is selected (i.e. profile gate is unlocked), a target layout
      // is fetched to replace currently displaying profile gates that was returned by BFF
      // instead of the original layout.
      case RENEW_TOKEN_SUCCESS: {
        const {
          layout: { requestedEntityId, requestedEntityType },
        } = getState();

        if (!requestedEntityType || !requestedEntityId) {
          break;
        }

        dispatch(fetchLayout(requestedEntityType, requestedEntityId));
        break;
      }
      default:
        break;
    }

    return next(action);
  };
